import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface EventSelectedTabState {
  selectedTab: number;
}

const initialState: EventSelectedTabState = {
  selectedTab: 0,
};

export const eventSelectedTabSlice = createSlice({
  name: "eventSelectedTab",
  initialState,
  reducers: {
    setSelectedTab: (state, action: PayloadAction<number>) => {
      state.selectedTab = action.payload;
    },
    resetSelectedTab: (state) => {
      state.selectedTab = 0;
    },
  },
});

export const { setSelectedTab, resetSelectedTab } = eventSelectedTabSlice.actions;
export default eventSelectedTabSlice.reducer;

